import React from "react";
import { useDispatch } from "react-redux";

import { UnprocessButton } from "./FooterButton";
import { toggleModal } from "app/store/transmission/slice/transmissionSlice";

import { USER_ROLES } from "static/constants";
import { getCurrentUserRole } from "utils/currentUser.util";

const ClinicProcessedButtons = ({ handleProcess }) => {
  const dispatch = useDispatch();
  const userRole = getCurrentUserRole();

  const unprocessByRole = {
    [USER_ROLES.CLINIC_ADMIN]: () =>
      handleProcess("unprocess", false, true, false, true),
    [USER_ROLES.PHYSICIAN]: () =>
      dispatch(
        toggleModal({
          type: "physicianUnprocessFromClinicProcessed",
          value: true,
        })
      ),
  };

  const onUnprocess = unprocessByRole[userRole];

  if (!onUnprocess) return null;

  return <UnprocessButton onClick={onUnprocess} />;
};

export default ClinicProcessedButtons;
